module.exports = __webpack_public_path__ + "sk.svg?253c193837ab28e6fbc39c28024e023f";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/sk.svg
// module id = 1613
// module chunks = 0